import { useRef } from "react";
import { Star, Quote } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const reviews = [
  {
    text:
      "Dies ist der beste Grill in der Gegend!! Einfach immer wieder ein Genuss.",
    author: "Google Bewertung",
  },
  {
    text:
      "Lecker, süß, schön und gemütlich — kommen gerne wieder. Das Gyros mit Metaxa-Sauce ist unschlagbar!",
    author: "Google Bewertung",
  },
  {
    text:
      "Tolle Atmosphäre, freundliches Personal und Portionen die wirklich sättigen. Unser Stammlokal in Höntrop.",
    author: "Google Bewertung",
  },
];

export default function Reviews() {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      id="bewertungen"
      ref={ref}
      data-testid="reviews-section"
      className="relative bg-[var(--niko-cream)] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <p className="reveal divider-leaf max-w-[200px] mx-auto mb-8">
            Bewertungen
          </p>
          <h2
            className="reveal reveal-delay-1 font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--niko-charcoal)] leading-[1.05]"
            data-testid="reviews-headline"
          >
            Was unsere{" "}
            <span className="italic text-[var(--niko-blue)]">Gäste</span> sagen
          </h2>
          <p className="reveal reveal-delay-2 mt-5 flex items-center justify-center gap-2 text-[var(--niko-charcoal)]/70">
            <span className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  className="w-4 h-4"
                  fill="#D4A843"
                  color="#D4A843"
                  strokeWidth={1.5}
                />
              ))}
            </span>
            <span className="font-medium text-[var(--niko-charcoal)]">
              4,7 von 5
            </span>
            <span>· 943 Google-Bewertungen</span>
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className={`reveal reveal-delay-${i + 1} relative bg-[var(--niko-dark)] text-white p-9 rounded-sm overflow-hidden group`}
            >
              <Quote
                className="absolute -top-2 -left-2 w-24 h-24 text-[var(--niko-gold)]/8 group-hover:text-[var(--niko-gold)]/15 transition-colors"
                strokeWidth={1}
              />
              <div className="relative flex gap-1 mb-6">
                {[0, 1, 2, 3, 4].map((s) => (
                  <Star
                    key={s}
                    className="w-4 h-4"
                    fill="#D4A843"
                    color="#D4A843"
                    strokeWidth={1.5}
                  />
                ))}
              </div>
              <p className="relative font-greek text-xl md:text-2xl leading-[1.45] text-white/90">
                "{r.text}"
              </p>
              <p className="relative mt-7 pt-5 border-t border-white/10 text-xs tracking-[0.22em] uppercase text-white/55">
                {r.author}
              </p>
            </article>
          ))}
        </div>

        <div className="reveal mt-14 text-center">
          <a
            href="https://www.google.com/search?q=Niko%27s+Grill+Bochum"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="reviews-google-link"
            className="inline-flex items-center gap-3 text-sm tracking-[0.18em] uppercase text-[var(--niko-charcoal)] border-b border-[var(--niko-gold)] pb-1 hover:text-[var(--niko-blue)] transition-colors"
          >
            Alle Bewertungen auf Google ansehen →
          </a>
        </div>
      </div>
    </section>
  );
}
